/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Configurenda2Inputs */

const en_coinvestments_configurenda2 = /** @type {(inputs: Coinvestments_Configurenda2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Default NDA`)
};

/**
* | output |
* | --- |
* | "Upload Default NDA" |
*
* @param {Coinvestments_Configurenda2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_configurenda2 = /** @type {((inputs?: Coinvestments_Configurenda2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Configurenda2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_configurenda2(inputs)
});
export { coinvestments_configurenda2 as "coInvestments_configureNda" }